import * as CryptoJS from 'crypto-js';
import { Injectable } from '@angular/core';
import { UtilContractCryptography } from './util.contract.cryptography';
import { RespositoryParameters } from 'src/app/4.repository/repository.parameters';

@Injectable({
    providedIn: 'root'
})
export class UtilCryptography implements UtilContractCryptography {

    constructor(
        private repoParameters: RespositoryParameters
    ){}

    encrypt(text: string): string{
        try{
            let characters = "abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTVWXYZ/";
            var ivString = "";
            for(var i = 0; i < 16; i++){
                ivString += characters.charAt(Math.floor(Math.random() * 62));
            }
            var encrypted = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(text.toString()), 
                CryptoJS.enc.Utf8.parse(this.repoParameters.getCryptoKey()), 
                {
                    iv: CryptoJS.enc.Utf8.parse(ivString),
                    mode: CryptoJS.mode.CBC
                }
            );
            return ivString + encrypted.toString();
        }catch(ex){
            return "-- Error: 0x01 --"
        }
    }

    decrypt(text: string): string {
        if(text.length > 16){
            try{
                let ivString = text.substring(0, 16);
                let encryptedText = text.substring(16, text.length);
                var decrypted = CryptoJS.AES.decrypt(
                    encryptedText, 
                    CryptoJS.enc.Utf8.parse(this.repoParameters.getCryptoKey()), 
                    {
                        iv: CryptoJS.enc.Utf8.parse(ivString),
                        mode: CryptoJS.mode.CBC
                    }
                );
                return decrypted.toString(CryptoJS.enc.Utf8);
            }catch(ex){
                return "-- Error: 0x02 --"
            }
        }else{
            return "-- Error: 0x01 --"
        }
    }

}